/* eslint-disable extra-rules/no-commented-out-code */
import React from "react";
import axios from "axios";
//Limitless imports
import { createPlatformURL, createMutationHeaders } from "../../../portal/utils/SecurePlatformAPIUtils";
import { log as pilog } from "@limitless/common/utils/Logging";
import { useExpertMessageContext } from "../expert-message/ExpertMessageContext";
import { useNotificationContext } from "@limitless/common/hooks";
const INITIAL_STATE = {
  loading: false,
  hasClicked: false
};
const ADD_DIALOGUE = "addExpertDialogue";
const RETRY = "retry";
export const useClientActions = (message, translate) => {
  const [clientAction, setClientAction] = React.useState(INITIAL_STATE);
  const {
    stopLoading,
    toggleMessageLoading,
    addTempDialogue
  } = useExpertMessageContext();
  const {
    addFailureNotification
  } = useNotificationContext();
  const log = pilog.getLogger("useClientActions");
  const loadClientAction = () => {
    toggleMessageLoading();
    setClientAction({
      ...clientAction,
      loading: true,
      hasClicked: true
    });
    axios.put(createPlatformURL("integration/commands/assign"), {}, createMutationHeaders({
      messageId: message.messageId
    })).then(result => processResult(result.data)).catch(error => {
      setClientAction({
        ...clientAction,
        loading: false,
        hasClicked: true
      });
      stopLoading();
      // processResult({
      //     uiAction: RETRY,
      //     newDialogueContent: "Here's some new dialogue, enjoy!"
      // });
      log.error("Unexpected client action integration error %o", error);
    });
  };
  const processResult = result => {
    const {
      uiAction,
      newDialogueContent
    } = result;
    const fakeDialogue = {
      dialogueId: "000-111-222-333",
      origin: "expert",
      type: "standard",
      created: new Date().getTime(),
      author: "Limitless"
    };
    switch (uiAction) {
      case ADD_DIALOGUE:
        {
          addTempDialogue(translate(newDialogueContent), null, fakeDialogue, {
            hasAddedDialogue: true,
            loading: false
          }, false);
          break;
        }
      case RETRY:
        {
          setClientAction({
            ...clientAction,
            loading: false,
            hasClicked: false
          });
          stopLoading();
          addFailureNotification(translate("An error occurred, please try again"));
          break;
        }
      default:
        setClientAction({
          ...clientAction,
          loading: false,
          hasClicked: true
        });
        stopLoading();
        break;
    }
  };
  return {
    clientAction,
    loadClientAction
  };
};